import type { Offer } from "./preparation-studio.js";

// Any substantive edit needs a fresh owner confirmation. A previously
// authorized price is suspended until it is explicitly authorized again.
export function editOfferForReview(offer: Offer, patch: Partial<Offer>): Offer {
  const keys: Array<keyof Offer> = ["kind", "name", "description", "priceMode", "priceCents", "billingPeriod", "conditions", "priceVisibility"];
  const next = { ...offer, ...patch };
  if (!keys.some(key => next[key] !== offer[key])) return offer;
  return { ...next, reviewed: false, priceVisibility: next.priceVisibility === "may_disclose" ? "confirm_before_disclose" : next.priceVisibility };
}
